import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const AddScheduleForm = lazyLoader(
  () => import("Containers/Schedules/AddSchedule/AddScheduleForm")
);

export const AddSchedule = () => {
  return (
    <Layout>
      <AddScheduleForm isEdit={false} />
    </Layout>
  );
};
